const React = require('react');
const ErrorIcon = require('../../icons/Error');


module.exports = (props) => {
  return (
    <div
      className="p40 bgF rlv bs bcC b5 r30 c0 f17
        ff$1 lh150% lts-.005em w600 wmax"
    >
      <div>
        <div>
          <ErrorIcon className="mhA w70 c0"/>
        </div>
        <div className="mt20 f24 lh tl">Error</div>
        <div className="mt20 (dn|cCT|olN|tdU|o70:h!)>a">{props.message}</div>
      </div>
    </div>
  );
};
